define("checkout/components/seamless-checkout/checkout-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "checkout/utils/upgrade-downgrade", "later/config/environment", "later/utils/load-script", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _upgradeDowngrade, _environment, _loadScript, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _trackCloseCheckout, _trackSelectedPlan;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"checkout/utils/upgrade-downgrade",0,"later/config/environment",0,"later/utils/load-script",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Containers::LoadCheckoutData
    @onTransactionComplete={{this.handleTransactionComplete}}
    @planType={{this.selectedPlanType}}
    as |checkout checkoutActions proration|
  >
  
    <Shared::Modal
      @closable={{and (not checkout.isLoading) this.canCloseModal}}
      @close={{fn this.closeCheckoutModal (or checkout.hasUnsavedCheckoutChanges this.hasAddressChanges)}}
      @closeButtonQaClass="qa--seamless__closeIcon"
      @focusTrap={{true}}
      @onAttemptedClose={{this.alertCheckoutInProgress}}
      class={{if this.isSeamlessCheckoutInProgress "is--disabled" ""}}
      as |modal|
    >
      <modal.card @portrait={{false}} class="tPF--modalCard qa--seamlessCheckout">
        {{#unless checkout.isLoading}}
          <div class="u--hide--desktop">
            <modal.card-header>
              <h2 class="o--modalHeader__title">
                {{#if this.titleTranslationPath}}
                  {{t this.titleTranslationPath htmlSafe=true planName=checkout.planName}}
                {{/if}}
              </h2>
            </modal.card-header>
          </div>
          <modal.card-body class="u--p__0">
            <div class="{{concat 'tCH--plan--' this.selectedPlanType}} tPF--checkoutWrapper">
              <div class="tPF--checkout--details">
                <div class="u--m__b__md">
                  {{! Feature Banner }}
                  {{#if this.selectedFeature}}
                    <SeamlessCheckout::FeatureBanner
                      @feature={{this.selectedFeature}}
                      @plan={{checkout.selectedSubscriptionPlan}}
                      @socialProfileType={{this.socialProfileType}}
                    />
                  {{else}}
                    {{#if this.showBackToTrialPlans}}
                      {{! Back Button }}
                      <Shared::Ui::Button
                        @isDisabled={{this.isSeamlessCheckoutInProgress}}
                        @onClick={{fn
                          this.goBackToTrialPlans
                          (or checkout.hasUnsavedCheckoutChanges this.hasAddressChanges)
                        }}
                        @variant="none"
                        class="tPF--checkout__prev"
                      >
                        {{svg-jar "nav-left" class="o--icon"}}
                        <span>{{t "plans.view_all_plans"}}</span>
                      </Shared::Ui::Button>
                    {{/if}}
                  {{/if}}
                  {{! Note:  Mobile uses modal.card-header }}
                  <h2 class="tCK--title u--hide--mobile qa--seamless_title">
                    {{#if this.titleTranslationPath}}
                      {{t this.titleTranslationPath htmlSafe=true planName=checkout.planName}}
                    {{/if}}
  
                    <Shared::Ui::Button
                      @class=""
                      @isDisabled={{this.isSeamlessCheckoutInProgress}}
                      @onClick={{this.toggleAllFeaturesModal}}
                      @variant="unstyled"
                    >
                      {{svg-jar "info" class="o--icon--md tCH--text--highlight u--cursor"}}
                      <span class="u--screenReaderOnly">{{t "plans.see_all_features"}}</span>
                    </Shared::Ui::Button>
                  </h2>
                </div>
  
                {{#unless this.isSimplifiedCheckout}}
                  <Interval
                    @displayMonthly={{this.canSelectMonthlyInterval}}
                    @isHorizontal={{true}}
                    @monthlyPlan={{checkout.monthlyPlan}}
                    @onInterval={{checkoutActions.handleInterval}}
                    @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                    @yearlyPlan={{checkout.yearlyPlan}}
                  />
                {{/unless}}
  
                <SeamlessCheckoutTable
                  @additionalAiCredits={{checkout.additionalAiCredits}}
                  @additionalSocialSetCount={{checkout.additionalSocialSetCount}}
                  @additionalTeamMemberCount={{checkout.additionalTeamMemberCount}}
                  @alertText={{checkout.alertText}}
                  @canAddAiCredits={{checkout.canAddAiCredits}}
                  @canAddons={{checkout.canAddons}}
                  @canApplyDiscount={{checkout.canApplyDiscount}}
                  @coupon={{checkout.coupon}}
                  @currentSubscriptionPlan={{checkout.currentSubscriptionPlan}}
                  @didAutoAddSocialSet={{checkout.didAutoAddSocialSet}}
                  @didAutoAddUser={{checkout.didAutoAddUser}}
                  @discount={{checkout.discount}}
                  @discountAmount={{checkout.discountAmount}}
                  @discountEndDate={{checkout.discountEndDate}}
                  @hasActiveTrial={{checkout.hasActiveTrial}}
                  @hasCheckoutChanges={{checkout.hasCheckoutChanges}}
                  @hasEnteredValidTaxId={{checkout.hasEnteredValidTaxId}}
                  @hasExpiringDiscount={{checkout.hasExpiringDiscount}}
                  @initialSocialSetCount={{checkout.initialSocialSetCount}}
                  @initialTeamMemberCount={{checkout.initialTeamMemberCount}}
                  @isEligibleForTrial={{checkout.isEligibleForTrial}}
                  @isMonthly={{checkout.isMonthly}}
                  @onAiCreditsChange={{checkoutActions.handleAiCreditsChange}}
                  @onSocialSetChange={{checkoutActions.handleSocialSetChange}}
                  @onTeamMemberChange={{checkoutActions.handleTeamMemberChange}}
                  @proration={{proration}}
                  @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                  @taxIdData={{checkout.taxIdData}}
                  @totalAiCreditCost={{checkout.totalAiCreditCost}}
                  @totalAiCredits={{checkout.totalAiCredits}}
                  @totalCost={{checkout.totalCost}}
                  @totalSocialSetCost={{checkout.totalSocialSetCost}}
                  @totalTeamMemberCost={{checkout.totalTeamMemberCost}}
                />
              </div>
  
              {{! Payment Details }}
              <div class="tPF--checkout--payment">
                <p class="u--text--md u--text tCH--text--highlight">
                  {{t "plans.checkout.plan.step_2"}}
                </p>
  
                <Payment::PaymentMethod
                  @hasActiveSubscription={{checkout.hasActiveSubscription}}
                  @isDisabled={{this.isSeamlessCheckoutInProgress}}
                  @onStripePaymentElementChange={{checkoutActions.handleStripePaymentElementChange}}
                  @onStripePaymentElementSaved={{checkoutActions.handleStripePaymentElementSaved}}
                  @paymentMethod={{checkout.stripeCard}}
                  @planType={{this.selectedPlanType}}
                />
  
                <Payment::Address
                  @hideEditingAddress={{this.hideEditingAddress}}
                  @isDisabled={{this.isSeamlessCheckoutInProgress}}
                  @isEditingAddress={{this.isEditingAddress}}
                  @setEditingAddress={{this.setEditingAddress}}
                />
  
                <Payment::TaxId
                  @hasTaxId={{checkout.hasTaxId}}
                  @taxIdChangeset={{checkout.taxIdChangeset}}
                  @taxIdData={{checkout.taxIdData}}
                  @validateTaxId={{checkoutActions.validateTaxId}}
                />
  
                <Payment::Coupon
                  @isDisabled={{this.isSeamlessCheckoutInProgress}}
                  @isVisible={{checkout.canShowCouponForm}}
                  @onCoupon={{checkoutActions.handleCoupon}}
                  @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
                />
  
                <div class="tPF--checkout__footer">
                  <SeamlessCheckout::ReviewChangesButton
                    @handleChangePlanRunning={{checkout.handleChangePlan.isRunning}}
                    @hasChanges={{checkout.hasCheckoutChanges}}
                    @hasCompleteAddress={{this.hasCompleteAddress}}
                    @hasUpcomingPlanChanges={{checkout.subscription.hasUpcomingPlanChanges}}
                    @isVisible={{and checkout.hasActiveSubscription (not checkout.hasActiveTrial)}}
                    @onClickAction={{toggle "infoModalVisible" this}}
                  />
                  <CheckoutButton
                    @hasActiveCancelledSubscription={{checkout.hasActiveCancelledSubscription}}
                    @hasActiveSubscription={{checkout.hasActiveSubscription}}
                    @hasActiveTrial={{checkout.hasActiveTrial}}
                    @hasAddonChange={{checkout.hasAddonChange}}
                    @hasCompleteAddress={{this.hasCompleteAddress}}
                    @isEligibleForTrial={{checkout.isEligibleForTrial}}
                    @isOnCardlessTrial={{checkout.isOnCardlessTrial}}
                    @isPaymentMethodComplete={{checkout.isPaymentMethodComplete}}
                    @isSameInterval={{checkout.isSameInterval}}
                    @isSamePlan={{checkout.isSamePlan}}
                    @onChangePlan={{checkoutActions.handleChangePlan}}
                    @onCheckout={{checkoutActions.handleCheckout}}
                    @savedStripeCard={{checkout.stripeCard}}
                    @showMissingInfoMesage={{false}}
                  />
                  <div class="u--text--light u--p__t__sm qa--checkout__summary--secure">
                    {{svg-jar "lock" class="o--icon u--m__r__xs"}}
                    {{t "plans.checkout.plan.summary_secure"}}
                  </div>
                </div>
              </div>
            </div>
          </modal.card-body>
        {{/unless}}
      </modal.card>
    </Shared::Modal>
  
    <SeamlessCheckout::PlanInfoModal
      @additionalAiCredits={{checkout.additionalAiCredits}}
      @additionalSocialSetCount={{checkout.additionalSocialSetCount}}
      @additionalTeamMemberCount={{checkout.additionalTeamMemberCount}}
      @closeModal={{toggle "infoModalVisible" this}}
      @currentSubscriptionPlan={{checkout.currentSubscriptionPlan}}
      @didAddCoupon={{checkout.didAddCoupon}}
      @didRemoveDiscount={{checkout.didRemoveDiscount}}
      @discountAmount={{checkout.discountAmount}}
      @hasCheckoutChanges={{checkout.hasCheckoutChanges}}
      @hasExpiringDiscount={{checkout.hasExpiringDiscount}}
      @initialAiCreditsCount={{checkout.initialAiCreditsCount}}
      @initialSocialSetCount={{checkout.initialSocialSetCount}}
      @initialTeamMemberCount={{checkout.initialTeamMemberCount}}
      @isOnLegacyPlan={{checkout.isOnLegacyPlan}}
      @isVisible={{this.infoModalVisible}}
      @onChangePlan={{checkoutActions.handleChangePlan}}
      @proration={{proration}}
      @selectedSubscriptionPlan={{checkout.selectedSubscriptionPlan}}
    />
  
    {{#if this.showAllFeaturesModal}}
      <Shared::Upgrade::AllFeaturesModal
        @close={{this.toggleAllFeaturesModal}}
        @focusTrap={{true}}
        @isMonthly={{checkout.isMonthly}}
        @planType={{this.selectedPlanType}}
      />
    {{/if}}
  </Containers::LoadCheckoutData>
  */
  {
    "id": "8XKMl2GQ",
    "block": "[[[8,[39,0],null,[[\"@onTransactionComplete\",\"@planType\"],[[30,0,[\"handleTransactionComplete\"]],[30,0,[\"selectedPlanType\"]]]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[39,1],[[16,0,[52,[30,0,[\"isSeamlessCheckoutInProgress\"]],\"is--disabled\",\"\"]]],[[\"@closable\",\"@close\",\"@closeButtonQaClass\",\"@focusTrap\",\"@onAttemptedClose\"],[[28,[37,3],[[28,[37,4],[[30,1,[\"isLoading\"]]],null],[30,0,[\"canCloseModal\"]]],null],[28,[37,5],[[30,0,[\"closeCheckoutModal\"]],[28,[37,6],[[30,1,[\"hasUnsavedCheckoutChanges\"]],[30,0,[\"hasAddressChanges\"]]],null]],null],\"qa--seamless__closeIcon\",true,[30,0,[\"alertCheckoutInProgress\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,4,[\"card\"]],[[24,0,\"tPF--modalCard qa--seamlessCheckout\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,1,[\"isLoading\"]]],[[[1,\"        \"],[10,0],[14,0,\"u--hide--desktop\"],[12],[1,\"\\n          \"],[8,[30,4,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n            \"],[10,\"h2\"],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n\"],[41,[30,0,[\"titleTranslationPath\"]],[[[1,\"                \"],[1,[28,[35,8],[[30,0,[\"titleTranslationPath\"]]],[[\"htmlSafe\",\"planName\"],[true,[30,1,[\"planName\"]]]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[30,4,[\"card-body\"]],[[24,0,\"u--p__0\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[15,0,[29,[[28,[37,9],[\"tCH--plan--\",[30,0,[\"selectedPlanType\"]]],null],\" tPF--checkoutWrapper\"]]],[12],[1,\"\\n            \"],[10,0],[14,0,\"tPF--checkout--details\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n\"],[41,[30,0,[\"selectedFeature\"]],[[[1,\"                  \"],[8,[39,10],null,[[\"@feature\",\"@plan\",\"@socialProfileType\"],[[30,0,[\"selectedFeature\"]],[30,1,[\"selectedSubscriptionPlan\"]],[30,0,[\"socialProfileType\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showBackToTrialPlans\"]],[[[1,\"                    \"],[8,[39,11],[[24,0,\"tPF--checkout__prev\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isSeamlessCheckoutInProgress\"]],[28,[37,5],[[30,0,[\"goBackToTrialPlans\"]],[28,[37,6],[[30,1,[\"hasUnsavedCheckoutChanges\"]],[30,0,[\"hasAddressChanges\"]]],null]],null],\"none\"]],[[\"default\"],[[[[1,\"\\n                      \"],[1,[28,[35,12],[\"nav-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n                      \"],[10,1],[12],[1,[28,[35,8],[\"plans.view_all_plans\"],null]],[13],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]]],[1,\"                \"],[10,\"h2\"],[14,0,\"tCK--title u--hide--mobile qa--seamless_title\"],[12],[1,\"\\n\"],[41,[30,0,[\"titleTranslationPath\"]],[[[1,\"                    \"],[1,[28,[35,8],[[30,0,[\"titleTranslationPath\"]]],[[\"htmlSafe\",\"planName\"],[true,[30,1,[\"planName\"]]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n                  \"],[8,[39,11],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[\"\",[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,0,[\"toggleAllFeaturesModal\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,12],[\"info\"],[[\"class\"],[\"o--icon--md tCH--text--highlight u--cursor\"]]]],[1,\"\\n                    \"],[10,1],[14,0,\"u--screenReaderOnly\"],[12],[1,[28,[35,8],[\"plans.see_all_features\"],null]],[13],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"isSimplifiedCheckout\"]]],[[[1,\"                \"],[8,[39,13],null,[[\"@displayMonthly\",\"@isHorizontal\",\"@monthlyPlan\",\"@onInterval\",\"@selectedSubscriptionPlan\",\"@yearlyPlan\"],[[30,0,[\"canSelectMonthlyInterval\"]],true,[30,1,[\"monthlyPlan\"]],[30,2,[\"handleInterval\"]],[30,1,[\"selectedSubscriptionPlan\"]],[30,1,[\"yearlyPlan\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n              \"],[8,[39,14],null,[[\"@additionalAiCredits\",\"@additionalSocialSetCount\",\"@additionalTeamMemberCount\",\"@alertText\",\"@canAddAiCredits\",\"@canAddons\",\"@canApplyDiscount\",\"@coupon\",\"@currentSubscriptionPlan\",\"@didAutoAddSocialSet\",\"@didAutoAddUser\",\"@discount\",\"@discountAmount\",\"@discountEndDate\",\"@hasActiveTrial\",\"@hasCheckoutChanges\",\"@hasEnteredValidTaxId\",\"@hasExpiringDiscount\",\"@initialSocialSetCount\",\"@initialTeamMemberCount\",\"@isEligibleForTrial\",\"@isMonthly\",\"@onAiCreditsChange\",\"@onSocialSetChange\",\"@onTeamMemberChange\",\"@proration\",\"@selectedSubscriptionPlan\",\"@taxIdData\",\"@totalAiCreditCost\",\"@totalAiCredits\",\"@totalCost\",\"@totalSocialSetCost\",\"@totalTeamMemberCost\"],[[30,1,[\"additionalAiCredits\"]],[30,1,[\"additionalSocialSetCount\"]],[30,1,[\"additionalTeamMemberCount\"]],[30,1,[\"alertText\"]],[30,1,[\"canAddAiCredits\"]],[30,1,[\"canAddons\"]],[30,1,[\"canApplyDiscount\"]],[30,1,[\"coupon\"]],[30,1,[\"currentSubscriptionPlan\"]],[30,1,[\"didAutoAddSocialSet\"]],[30,1,[\"didAutoAddUser\"]],[30,1,[\"discount\"]],[30,1,[\"discountAmount\"]],[30,1,[\"discountEndDate\"]],[30,1,[\"hasActiveTrial\"]],[30,1,[\"hasCheckoutChanges\"]],[30,1,[\"hasEnteredValidTaxId\"]],[30,1,[\"hasExpiringDiscount\"]],[30,1,[\"initialSocialSetCount\"]],[30,1,[\"initialTeamMemberCount\"]],[30,1,[\"isEligibleForTrial\"]],[30,1,[\"isMonthly\"]],[30,2,[\"handleAiCreditsChange\"]],[30,2,[\"handleSocialSetChange\"]],[30,2,[\"handleTeamMemberChange\"]],[30,3],[30,1,[\"selectedSubscriptionPlan\"]],[30,1,[\"taxIdData\"]],[30,1,[\"totalAiCreditCost\"]],[30,1,[\"totalAiCredits\"]],[30,1,[\"totalCost\"]],[30,1,[\"totalSocialSetCost\"]],[30,1,[\"totalTeamMemberCost\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\\n\"],[1,\"            \"],[10,0],[14,0,\"tPF--checkout--payment\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--md u--text tCH--text--highlight\"],[12],[1,\"\\n                \"],[1,[28,[35,8],[\"plans.checkout.plan.step_2\"],null]],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[8,[39,15],null,[[\"@hasActiveSubscription\",\"@isDisabled\",\"@onStripePaymentElementChange\",\"@onStripePaymentElementSaved\",\"@paymentMethod\",\"@planType\"],[[30,1,[\"hasActiveSubscription\"]],[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,2,[\"handleStripePaymentElementChange\"]],[30,2,[\"handleStripePaymentElementSaved\"]],[30,1,[\"stripeCard\"]],[30,0,[\"selectedPlanType\"]]]],null],[1,\"\\n\\n              \"],[8,[39,16],null,[[\"@hideEditingAddress\",\"@isDisabled\",\"@isEditingAddress\",\"@setEditingAddress\"],[[30,0,[\"hideEditingAddress\"]],[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,0,[\"isEditingAddress\"]],[30,0,[\"setEditingAddress\"]]]],null],[1,\"\\n\\n              \"],[8,[39,17],null,[[\"@hasTaxId\",\"@taxIdChangeset\",\"@taxIdData\",\"@validateTaxId\"],[[30,1,[\"hasTaxId\"]],[30,1,[\"taxIdChangeset\"]],[30,1,[\"taxIdData\"]],[30,2,[\"validateTaxId\"]]]],null],[1,\"\\n\\n              \"],[8,[39,18],null,[[\"@isDisabled\",\"@isVisible\",\"@onCoupon\",\"@selectedSubscriptionPlan\"],[[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,1,[\"canShowCouponForm\"]],[30,2,[\"handleCoupon\"]],[30,1,[\"selectedSubscriptionPlan\"]]]],null],[1,\"\\n\\n              \"],[10,0],[14,0,\"tPF--checkout__footer\"],[12],[1,\"\\n                \"],[8,[39,19],null,[[\"@handleChangePlanRunning\",\"@hasChanges\",\"@hasCompleteAddress\",\"@hasUpcomingPlanChanges\",\"@isVisible\",\"@onClickAction\"],[[30,1,[\"handleChangePlan\",\"isRunning\"]],[30,1,[\"hasCheckoutChanges\"]],[30,0,[\"hasCompleteAddress\"]],[30,1,[\"subscription\",\"hasUpcomingPlanChanges\"]],[28,[37,3],[[30,1,[\"hasActiveSubscription\"]],[28,[37,4],[[30,1,[\"hasActiveTrial\"]]],null]],null],[28,[37,20],[\"infoModalVisible\",[30,0]],null]]],null],[1,\"\\n                \"],[8,[39,21],null,[[\"@hasActiveCancelledSubscription\",\"@hasActiveSubscription\",\"@hasActiveTrial\",\"@hasAddonChange\",\"@hasCompleteAddress\",\"@isEligibleForTrial\",\"@isOnCardlessTrial\",\"@isPaymentMethodComplete\",\"@isSameInterval\",\"@isSamePlan\",\"@onChangePlan\",\"@onCheckout\",\"@savedStripeCard\",\"@showMissingInfoMesage\"],[[30,1,[\"hasActiveCancelledSubscription\"]],[30,1,[\"hasActiveSubscription\"]],[30,1,[\"hasActiveTrial\"]],[30,1,[\"hasAddonChange\"]],[30,0,[\"hasCompleteAddress\"]],[30,1,[\"isEligibleForTrial\"]],[30,1,[\"isOnCardlessTrial\"]],[30,1,[\"isPaymentMethodComplete\"]],[30,1,[\"isSameInterval\"]],[30,1,[\"isSamePlan\"]],[30,2,[\"handleChangePlan\"]],[30,2,[\"handleCheckout\"]],[30,1,[\"stripeCard\"]],false]],null],[1,\"\\n                \"],[10,0],[14,0,\"u--text--light u--p__t__sm qa--checkout__summary--secure\"],[12],[1,\"\\n                  \"],[1,[28,[35,12],[\"lock\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n                  \"],[1,[28,[35,8],[\"plans.checkout.plan.summary_secure\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[4]]]]],[1,\"\\n\\n  \"],[8,[39,22],null,[[\"@additionalAiCredits\",\"@additionalSocialSetCount\",\"@additionalTeamMemberCount\",\"@closeModal\",\"@currentSubscriptionPlan\",\"@didAddCoupon\",\"@didRemoveDiscount\",\"@discountAmount\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@initialAiCreditsCount\",\"@initialSocialSetCount\",\"@initialTeamMemberCount\",\"@isOnLegacyPlan\",\"@isVisible\",\"@onChangePlan\",\"@proration\",\"@selectedSubscriptionPlan\"],[[30,1,[\"additionalAiCredits\"]],[30,1,[\"additionalSocialSetCount\"]],[30,1,[\"additionalTeamMemberCount\"]],[28,[37,20],[\"infoModalVisible\",[30,0]],null],[30,1,[\"currentSubscriptionPlan\"]],[30,1,[\"didAddCoupon\"]],[30,1,[\"didRemoveDiscount\"]],[30,1,[\"discountAmount\"]],[30,1,[\"hasCheckoutChanges\"]],[30,1,[\"hasExpiringDiscount\"]],[30,1,[\"initialAiCreditsCount\"]],[30,1,[\"initialSocialSetCount\"]],[30,1,[\"initialTeamMemberCount\"]],[30,1,[\"isOnLegacyPlan\"]],[30,0,[\"infoModalVisible\"]],[30,2,[\"handleChangePlan\"]],[30,3],[30,1,[\"selectedSubscriptionPlan\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"    \"],[8,[39,23],null,[[\"@close\",\"@focusTrap\",\"@isMonthly\",\"@planType\"],[[30,0,[\"toggleAllFeaturesModal\"]],true,[30,1,[\"isMonthly\"]],[30,0,[\"selectedPlanType\"]]]],null],[1,\"\\n\"]],[]],null]],[1,2,3]]]]]],[\"checkout\",\"checkoutActions\",\"proration\",\"modal\"],false,[\"containers/load-checkout-data\",\"shared/modal\",\"if\",\"and\",\"not\",\"fn\",\"or\",\"unless\",\"t\",\"concat\",\"seamless-checkout/feature-banner\",\"shared/ui/button\",\"svg-jar\",\"interval\",\"seamless-checkout-table\",\"payment/payment-method\",\"payment/address\",\"payment/tax-id\",\"payment/coupon\",\"seamless-checkout/review-changes-button\",\"toggle\",\"checkout-button\",\"seamless-checkout/plan-info-modal\",\"shared/upgrade/all-features-modal\"]]",
    "moduleName": "checkout/components/seamless-checkout/checkout-modal.hbs",
    "isStrictMode": false
  });
  let CheckoutModalComponent = _exports.default = (_class = (_trackCloseCheckout = /*#__PURE__*/new WeakSet(), _trackSelectedPlan = /*#__PURE__*/new WeakSet(), class CheckoutModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      // Note: Google script to load recaptcha for seamless checkout
      // https://developers.google.com/recaptcha/docs/v3
      _classPrivateMethodInitSpec(this, _trackSelectedPlan);
      _classPrivateMethodInitSpec(this, _trackCloseCheckout);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "plans", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "segment", _descriptor8, this);
      _initializerDefineProperty(this, "segmentEvents", _descriptor9, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor10, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor11, this);
      _initializerDefineProperty(this, "isEditingAddress", _descriptor12, this);
      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor13, this);
      _defineProperty(this, "currentPlanTypeAtStart", void 0);
      _defineProperty(this, "isOnLegacyPlan", false);
      _defineProperty(this, "isEligibleForTrial", false);
      (0, _loadScript.default)(`https://www.google.com/recaptcha/api.js?render=${_environment.default.APP.googleRecaptchaSiteKey}`);

      // Note: to ensure modal title does not reactively change when subscription updates during form submission.
      this.currentPlanTypeAtStart = this.subscriptions.subscriptionPlan?.planType;
      this.isOnLegacyPlan = this.auth.currentAccount.isOnLegacyPlan;
      this.isEligibleForTrial = Boolean(this.auth.currentAccount?.canTrialPlan);
      _classPrivateMethodGet(this, _trackSelectedPlan, _trackSelectedPlan2).call(this);
    }
    get canSelectMonthlyInterval() {
      return this.plans.canSelectMonthlyInterval;
    }
    get canCloseModal() {
      return !this.isSeamlessCheckoutInProgress && this.seamlessCheckoutManager.canCloseCheckoutModal;
    }
    get titleTranslationPath() {
      if (!this.currentPlanTypeAtStart || !this.selectedPlanType) {
        return '';
      }
      const currentPlanAtStart = this.plans.getPlan(this.currentPlanTypeAtStart);
      const selectedPlan = this.plans.getPlan(this.selectedPlanType);
      const plansAvailable = [...this.plans.plans, ...this.plans.agencyPlans];
      if (this.isEligibleForTrial) {
        return 'plans.checkout.title_trial';
      } else if (this.currentPlanTypeAtStart === this.selectedPlanType) {
        return 'plans.checkout.title_manage';

        // Note: Legacy plans are not included in the plans data from plans.getPlan so they cannot be used with isUpgrade or isDowngrade
        // for seamless checkout purposes, if a legacy user is checking out we will display the upgrade copy
      } else if (this.isOnLegacyPlan || (0, _upgradeDowngrade.isUpgrade)(currentPlanAtStart, selectedPlan, plansAvailable)) {
        return 'plans.checkout.title_upgrade';
      } else if ((0, _upgradeDowngrade.isDowngrade)(currentPlanAtStart, selectedPlan, plansAvailable)) {
        return 'plans.checkout.title_downgrade';
      }
      return '';
    }
    get selectedPlanType() {
      return this.seamlessCheckoutManager.selectedPlanType;
    }
    get selectedFeature() {
      return this.seamlessCheckoutManager.selectedFeature;
    }
    get socialProfileType() {
      return this.seamlessCheckoutManager.socialProfileType;
    }
    get planName() {
      return this.intl.t(`plans.plan_names.${this.selectedPlanType}`);
    }
    get hasCompleteAddress() {
      const requiresAddress = this.address.addressCollectionEnabled && this.address.isFullAddressRequired;
      if (!requiresAddress) {
        return true;
      }
      return this.address.isSavedAddressValid && !this.isEditingAddress && !this.address.hasUnsavedChanges;
    }
    get hasAddressChanges() {
      return this.address.hasUnsavedChanges;
    }
    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }
    get isSimplifiedCheckout() {
      return this.seamlessCheckoutManager.isSimplifiedCheckout;
    }
    get hasActiveSubscription() {
      return Boolean(this.auth.currentAccount.hasActiveSubscription);
    }
    get showBackToTrialPlans() {
      const isOnPlansPage = this.router.currentRouteName === 'plans.index';
      return this.isEligibleForTrial && !isOnPlansPage;
    }
    hideEditingAddress() {
      this.isEditingAddress = false;
    }
    setEditingAddress() {
      this.isEditingAddress = true;
    }
    handleTransactionComplete() {
      this.seamlessCheckoutManager.successCallback?.();
      if (this.seamlessCheckoutManager.shouldShowCheckoutSuccessModal) {
        this.seamlessCheckoutManager.openCheckoutSuccessModal();
      }
      this.seamlessCheckoutManager.successCallback = null;
    }
    toggleAllFeaturesModal() {
      this.showAllFeaturesModal = !this.showAllFeaturesModal;
    }
    alertCheckoutInProgress() {
      if (this.isSeamlessCheckoutInProgress) {
        this.alerts.info('', {
          title: this.intl.t('alerts.plans.checkout.checkout_in_progress')
        });
      }
    }
    async goBackToTrialPlans() {
      let hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (hasChanges) {
        const didConfirm = await this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.your_changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });
        if (!didConfirm) {
          return;
        }
      }

      //Note: for now, back always goes to trial plans.
      this.seamlessCheckoutManager.openTrialPlansModal({
        // Note: When switching between the checkout and trial plans modal, we want to retain
        // the same state, otherwise this gets unset in the service
        canCloseCheckoutModal: this.seamlessCheckoutManager.canCloseCheckoutModal
      });
    }
    async closeCheckoutModal() {
      let hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.seamlessCheckoutManager.isCheckoutInProgress) {
        return;
      }
      if (hasChanges) {
        const didConfirm = await this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.your_changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        });
        if (!didConfirm) {
          return;
        }
      }
      _classPrivateMethodGet(this, _trackCloseCheckout, _trackCloseCheckout2).call(this);
      this.seamlessCheckoutManager.closeCheckoutModal();
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isEditingAddress", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "hideEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEditingAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setEditingAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTransactionComplete", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTransactionComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFeaturesModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alertCheckoutInProgress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "alertCheckoutInProgress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBackToTrialPlans", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goBackToTrialPlans"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCheckoutModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCheckoutModal"), _class.prototype)), _class);
  function _trackCloseCheckout2() {
    if (!this.selectedPlanType) {
      return;
    }
    if (this.auth.currentAccount?.canTrialPlan) {
      this.segment.track(`closed-seamless-trial-checkout-${this.selectedPlanType}`);
    } else {
      this.segment.track(`closed-seamless-checkout-${this.selectedPlanType}`);
    }
  }
  function _trackSelectedPlan2() {
    if (!this.selectedPlanType) {
      return;
    }
    if (this.auth.currentAccount?.canTrialPlan) {
      const page = this.seamlessCheckoutManager.location;
      if (page) {
        this.segment.track('selected-plan-for-trial', {
          plan: this.selectedPlanType,
          page
        });
      }
    } else {
      this.segmentEvents.trackWithGAIntegration('selected-plan', {
        plan: this.selectedPlanType
      });
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckoutModalComponent);
});